import {
payBTC,signBTC,
payETH,signETH,
payNEO,signNEO,
payWAV,signWAV,
payLSK,signLSK,
payDAI,
payUSDT,
payNRG,payEMB
}
from './index';

let funcs = {
payBTC,signBTC,
payETH,signETH,
payNEO,signNEO,
payWAV,signWAV,
payLSK,signLSK,
payDAI,
payUSDT,
payNRG,payEMB
}

export async function scheduleTransfer({password,amount,to,chain},dispatch,state,done) {
  let getState = () => {return state}
  await funcs[`pay${chain}`]({password,amount,to},done)(dispatch,getState)
}
